function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".canaryConfig_svg__st0,.canaryConfig_svg__st1{fill:none}.canaryConfig_svg__st1{stroke:#000;stroke-linecap:round;stroke-linejoin:round}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "canaryConfig_svg__st0",
  d: "M16 4.6v1.9l1.9-1.1z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.8,
  cy: 4.2,
  r: 0.8
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "canaryConfig_svg__st1",
  cx: 17.8,
  cy: 17,
  r: 1.4
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "canaryConfig_svg__st1",
  d: "M19 11.5l.4 1.4c.1.5.6.8 1.1.7l1.4-.3c.7-.2 1.4.3 1.5 1 .1.4 0 .8-.3 1.2l-1 1.1c-.3.4-.3.9 0 1.3l1 1.1c.5.5.5 1.3-.1 1.8-.3.3-.7.4-1.2.3l-1.4-.3c-.5-.1-1 .2-1.1.7l-.3 1.1c-.2.7-.9 1.1-1.6.9-.4-.1-.7-.4-.9-.9l-.4-1.4c-.1-.5-.6-.8-1.1-.7l-1.4.3c-.7.2-1.4-.3-1.5-1-.1-.4 0-.8.3-1.2l1-1.1c.3-.4.3-.9 0-1.3l-1-1.1c-.5-.5-.5-1.3.1-1.8.3-.3.7-.4 1.2-.3l1.4.3c.5.1 1-.2 1.1-.7l.4-1.4c.2-.7.9-1.1 1.6-.9.4.4.7.8.8 1.2z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "canaryConfig_svg__st0",
  d: "M16 6.5l1.9-1.1-1.9-.8z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M18.8 4.9c-.1-.2-.3-.3-.5-.4l-2.5-1.1c-.7-2.3-2.9-3.7-5.3-3.4-2.7.3-4.7 2.6-4.7 5.3v.6c-1.6.1-3.1-.5-4.1-1.7-.4-.4-1-.4-1.4-.1-.2.3-.3.5-.3.8.3 3.3 1.7 5.6 4.1 6.9l-.6.6-2.4 2.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3h8.1c.6 0 .7-1 0-1H1.8s3.2-3.1 3.5-3.6c.3-.4-.2-.6-.2-.6C2.7 10.1 1.3 8 1 4.8c1.4 1.5 3.4 2.3 5.4 2 .2 0 .4-.3.4-.5v-1c0-2.2 1.6-4 3.7-4.3 2.2-.2 4.2 1.4 4.5 3.6v4.6c0 .7 1 .7 1 0V7.7l2.4-1.4c.5-.3.6-.9.4-1.4zM16 6.5V4.6l1.9.8L16 6.5z"
});

function SvgCanaryConfig(props) {
  return React.createElement("svg", _extends({
    id: "canaryConfig_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

export default __webpack_public_path__ + "canaryConfig.15eca.svg";
export { SvgCanaryConfig as ReactComponent };